
export function useStoreState(instance, moduleName) {
  return instance[moduleName]
}